
export const simple = type => () => ({ type });

export const withPayload = type => payload => ({ type, payload });

export const withLogic = (type, cb) => async (dispatch) => {
  dispatch(simple(type)()); // log that this action type has been called
  cb(dispatch); // execute logic
};
